webpackJsonp([25,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 08/09/2017.
	 */
	//js
	var Shared = __webpack_require__(10);
	var LanguageManager = __webpack_require__(6);
	var utils = __webpack_require__(3);
	var log = __webpack_require__(5)();
	
	//Styles
	__webpack_require__(763);
	
	$(function () {
	  Shared.shouldSetUpCreditsDialog = false;
	  Shared.init();
	
	  LandingsPage.init();
	});
	
	var LandingsPage = {};
	
	(function (LandingsPage) {
	  LandingsPage.init = function () {
	    setUpEventListeners();
	  };
	
	  function setUpEventListeners() {}
	})(LandingsPage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 12
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 11;


/***/ }),

/***/ 763:
47

});


// WEBPACK FOOTER //
// js/index.e1bb4378d1768ed94afe.js